import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { r } from './helpers';
import {
  CustomerAppShell,
  CustomerAuthPage,
  CustomerHomePage,
  CustomerOrdersPage,
  CustomerOrderViewPage,
  CustomerChatsPage,
  CustomerChatThreadPage,
  CustomerAccountPage,
  CustomerChangePasswordPage,
  CustomerOrderRoomPage,
  PublicShopInvoicePage,
} from '../lazyPages';

/** Customer subdomain (customer-{slug}.domain) — app + public order room. */
export function CustomerRoutes({ isCustomer }) {
  return (
    <>
      {r('/o/:token', <CustomerOrderRoomPage />)}
      {r('/invoice/:token', <PublicShopInvoicePage />)}
      {r('/login', isCustomer ? <Navigate to="/" replace /> : <CustomerAuthPage />)}
      {r('/register', isCustomer ? <Navigate to="/" replace /> : <CustomerAuthPage />)}
      {isCustomer ? (
        <Route element={<CustomerAppShell />}>
          <Route path="/" element={<CustomerHomePage />} />
          <Route path="/orders" element={<CustomerOrdersPage />} />
          <Route path="/orders/:orderId" element={<CustomerOrderViewPage />} />
          <Route path="/chats" element={<CustomerChatsPage />} />
          <Route path="/chats/new" element={<CustomerChatThreadPage isNew />} />
          <Route path="/chats/:chatId" element={<CustomerChatThreadPage />} />
          <Route path="/account" element={<CustomerAccountPage />} />
          <Route path="/account/password" element={<CustomerChangePasswordPage />} />
        </Route>
      ) : (
        <>
          {r('/', <CustomerAuthPage />)}
          {r('*', <Navigate to="/login" replace />)}
        </>
      )}
    </>
  );
}
